<template>
    <vViewManagerComponent :postList="postList" v-if="flag"></vViewManagerComponent>
</template>
<script>
import vViewManagerComponent from '../../listComponent/basicdata/viewManager/viewManagerComponent.vue';
export default {
    name: 'viewManager',
    components: {
        vViewManagerComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: false,
                setBtn: true,
                view_name: true,
                entity_name: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>